import React from "react";
import { BundleInterface } from "src/store/callrecorder/bundlesSlice";
import Card from "src/componets/Card";
import ListForm from "../../Products/_partials/_ListForm";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectProductEntities, ProductInterface, selectProductIds } from "../../../../store/callrecorder/productsSlice";
import { message } from "antd";
import { updateProducts } from "../../../../actions/callrecorder/bundlesActions";
import {EntityId} from "@reduxjs/toolkit";
import usePermissions from "src/hooks/usePermissions";

interface dataInterface {
  products: ProductInterface[],
  bundle_id: number
}

const _Products = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const products = useAppSelector(selectProductEntities);
  const productsIds = useAppSelector(selectProductIds);
  const { write_callrecorder } = usePermissions();

  if (!bundle) {
    return null;
  }

  const data: dataInterface = {
    products: [],
    bundle_id: bundle.id
  };

  productsIds.forEach((id: any) => {
    const product = products[id];

    if (product) {
      data.products.push(product);
    }
  });

  function onFinish(data: dataInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(result: dataInterface) {
    if (!bundle) {
      return;
    }

    const id = bundle.id;
    const newData: any = { products: [] };
    const resultIds: EntityId[] = result.products.map((product: any) => product.id);

    result.products.forEach((product: any) => {
      newData.products.push({
        id: product.id,
        productid: product.productid,
        amount: product.amount,
        price: product.price,
        foo: 'baz'
      })
    });

    productsIds.forEach((id: EntityId) => {
      if (!resultIds.includes(id)) {
        newData.products.push({
          id: id,
          _destroy: true
        })
      }
    });

    const resultAction = await dispatch(updateProducts({ bundleId: id, data: newData }));

    if (updateProducts.fulfilled.match(resultAction)) {
      message.success('Products updated successfully');
    }

    if (updateProducts.rejected.match(resultAction)) {
      const error = Array.isArray(resultAction.payload) ? resultAction.payload[0] : resultAction.error.message;

      message.error(error);
    }
  }

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Products</h4>

        <div style={{ maxWidth: 480 }}>
          {write_callrecorder ? (
            <ListForm
              onFinish={onFinish}
              data={data}
            />
          ) : (
            <ul style={{ paddingLeft: 20 }}>
              {data.products.map(product => (
                <li key={product.id}>
                  <code>{product.productid}</code> — {product.amount} — ${product.price}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Card>
    </>
  );
}

export default _Products;
